import React from 'react';
import NavigationButtons from '../../NavigationButtons';
import ContractSummaryCard from './ContractSummaryCard';

const MobileSignatureCompletedView = ({
  clientData,
  selectedOffer,
  onViewContract,
  onDownloadContract,
  onBack,
  onFinish
}) => (
  <div className="rg-request-confirmation-step rg-signature-completed-step">
    <section className="rg-signature-completed-step__header" aria-labelledby="signature-completed-title">
      <div className="rg-signature-completed-step__success-icon" aria-hidden="true">
        <i className="bi bi-check-lg"></i>
      </div>
      <h3 id="signature-completed-title" className="rg-request-step__title rg-request-step__title--success">
        Solicitud enviada a análisis de pago
      </h3>
      <p className="rg-request-step__subtitle rg-signature-completed-step__description">
        El contrato fue firmado y la solicitud quedó lista para revisión.
      </p>
      <span className="badge rounded-pill text-bg-success px-3 py-2 rg-signature-completed-step__status-badge">
        <i className="bi bi-check-circle me-2"></i>
        Estado: Análisis de pago
      </span>
    </section>

    <div className="rg-signature-completed-step__content">
      <ContractSummaryCard
        selectedOffer={selectedOffer}
        clientData={clientData}
        showContractActions={false}
        variant="compact"
      />

      <section className="rg-signature-panel rg-signature-completed-step__contract-card" aria-labelledby="signed-contract-title">
        <div className="rg-signature-panel__intro">
          <h5 id="signed-contract-title" className="rg-signature-panel__title">Contrato firmado</h5>
          <p className="rg-signature-panel__description">
            El contrato firmado ya quedó registrado en la solicitud.
          </p>
        </div>

        <div className="rg-signature-completed-step__actions">
          <button type="button" className="btn btn-primary" onClick={onViewContract}>
            <i className="bi bi-eye me-2"></i>
            Ver contrato
          </button>
          <button type="button" className="btn btn-outline-primary" onClick={onDownloadContract}>
            <i className="bi bi-download me-2"></i>
            Descargar contrato
          </button>
        </div>
      </section>
    </div>

    <NavigationButtons onBack={onBack} onNext={onFinish} nextLabel="Finalizar proceso" />
  </div>
);

export default MobileSignatureCompletedView;
